/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useRef } from 'react';
import clsx from 'clsx';
import customStyles from "../../../../../assets/styles/customStyles";
import { useDispatch, useSelector } from "react-redux";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { StateTable } from "./StateTable";
import actions from "../../redux/actions";
import crudActions from "../../../../CRUD/redux/actions";
import { Col, Image, Row, Space } from "antd";
import { Button, TextField, Box, FormControlLabel, Switch } from "@mui/material";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import MainHeader from "../../../../Shared/components/Header";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import { toast } from 'react-toastify';
import { NavLink } from "react-router-dom";
import ImportIcon from "../../../../../assets/images/icon_actions/Import.svg";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import usePrevious from "../../../../Shared/components/Previous";
import { emptyValidation } from "../../../../../helpers/validation";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { ImportExport } from "../../../../Shared/components/ImportExport";
import { checkCRUDPermission, checkComponentPermission } from '../../../../../helpers/utilities';
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";

const State = (props) => {
    const { stateDetails, countryDetails, stateLoader } = useSelector(state => state.addressReducer);
    const { createDetails, createError, createLoader, getList, getData } = useSelector(state => state.crudReducer);
    const [visible, setVisible] = useState(false);
    const [type, setType] = useState('import');
    const [importVisible, setImportVisible] = useState(false);
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const [name, setName] = useState('');
    const [shortName, setShortName] = useState('');
    const [countryId, setCountryId] = useState('');
    const [country, setCountry] = useState('');
    const [isUtgst, setIsUtgst] = useState(false);

    const dispatch = useDispatch();
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const [errorStateName, setErrorStateName] = useState(false);
    const [errorStateShortName, setErrorStateShortName] = useState(false);
    const [errorCountryId, setErrorCountryId] = useState(false);
    const [skip, setSkip] = useState(0);
    const limit = 25;
    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);

    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");

    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);

    const { roleManagement } = useSelector(state => state.authReducer);
    const { moduleType } = props;

    const handleOpen = () => {
        setVisible(true);
        emptyState();
        emptyStateInput();
    };

    const handleClose = () => {
        setVisible(false);
        emptyState();
        emptyStateInput();
    };

    const emptyState = () => {
        setErrorStateName(false);
        setErrorStateShortName(false);
        setErrorCountryId(false);
    }

    const emptyStateInput = () => {
        setName('');
        setCountryId('');
        setCountry('');
        setIsUtgst(false);
    }

    const createState = (e) => {
        e.preventDefault();
        let emptyStateName = emptyValidation('State Name', name);
        let emptyStateShortName = emptyValidation('Short Name', shortName);
        let emptyCountry = emptyValidation('Country', countryId, 'dropDown');
        emptyState();
        if (emptyStateName.isValid && emptyStateShortName.isValid && emptyCountry.isValid) {
            dispatch({
                type: crudActions.CREATE_DETAILS_START,
                url: 'state',
                title: "State",
                details: {
                    name: name,
                    shortName: shortName,
                    countryId: countryId,
                    isUtgst: isUtgst
                }
            });
        } else {
            if (emptyStateName.errors !== '') {
                setErrorStateName(emptyStateName.errors);
            } if (emptyCountry.errors !== '') {
                setErrorCountryId(emptyCountry.errors);
            } if (emptyStateShortName.errors !== '') {
                setErrorStateShortName(emptyStateShortName.errors);
            }
        }
    }

    useEffect(() => {
        if ((prevSearch !== undefined && search && search?.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    useEffect(() => {
        loadTasks();
    }, []);

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData?.length > 0) {
                    setLoadMore(true);
                    if (getData?.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const dispatchFilter = (sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["or"]: [] };
        if (search !== '') {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ shortName: { like: '%' + search.trim() + '%' } });
        }
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'state',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        });
    }

    const loadTasks = useCallback(() => {
        dispatch({
            type: actions.COUNTRY_DETAILS_START, url: 'country', filter: {
                order: 'id desc'
            }
        });
        dispatchFilter(sortBy, sortOrder);
    });

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            dispatchFilter(sortBy, sortOrder);
            setVisible(false);
            toast.dismiss();
            toast(createDetails);
            emptyStateInput();
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let error = createError.error.message;
            setErrorStateName(error);
        }
    }, [createDetails, createError]);


    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, s);
    }

    const customObject = (details, id) => {
        let a = details && details.filter((el) => { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const handleOpenImport = () => {
        setImportVisible(true);
        setType('import');
    }

    const handleImportClose = () => {
        setImportVisible(false);
    }

    const onExport = () => {
        loadImportExportData('State');
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        dispatch({
            type: actions.STATE_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'state',
            filter: {
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props} img={SettingsImg}
                title={moduleType !== undefined ? moduleType : 'Younote Admin'}
                links={[{ 'label': moduleType !== undefined ? moduleType : 'Younote Admin', 'link': moduleType === 'Admin' ? '/admin' : '/younote-admin' },
                { 'label': 'Address Management', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'State'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('State', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search'
                                                type='search'
                                                value={search}
                                                className={classes.comInput}
                                                required
                                                onChange={(e) => setSearch(e.target.value)}
                                                variant={'standard'}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                            {
                                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                    <Image
                                                        src={ClearIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                            }
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.vertiCalScrollOverFlowParent)}>
                                    <div className={classes.vertiCalScrollOverFlow}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' && checkComponentPermission('State', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    className={clsx(classes.customLink)}
                                                    onClick={() => onExport()}
                                                >
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('State', 'Action', 'Import') &&
                                                <NavLink
                                                    to="#"
                                                    className={clsx(classes.customLink)}
                                                    onClick={() => handleOpenImport()}
                                                >
                                                    <Image
                                                        src={ImportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && (checkCRUDPermission('State', 'create', 'Younote Admin') || checkCRUDPermission('State', 'create', 'Admin')) &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => handleOpen()}
                                                    className={clsx(classes.customLink)}
                                                >
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold, classes.fwMedium)}>Add</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('State', 'Action', 'Filter') &&
                                                <></>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <StateTable
                                loadTasks={() => dispatchFilter(sortBy, sortOrder)}
                                customObject={(details, id) => customObject(details, id)}
                                stateDetails={getList}
                                moduleType={moduleType}
                                loadMore={loadMore}
                                loadMoreContent={loadMoreContent}
                                loadMoreTask={() => loadMoreTask()}
                                countryDetails={countryDetails}
                                sortOrder={sortOrder} sortBy={sortBy}
                                roleManagement={roleManagement}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
                <PrimaryDrawer
                    anchor={'right'}
                    open={visible}
                    variant={'temporary'}
                    handleClose={() => handleClose()}
                    title={'Add State'}
                    width={"360px"}
                    className={clsx(classes.closeBackGround, classes.width100P)}
                    component={
                        <Box
                            className={clsx(classes.customForm, classes.removeUnderline)}
                            component="form"
                            autoComplete="off"
                            onSubmit={(e) => createState(e)}>
                            <div className={classes.customFormFlex}>
                                <TextField autoComplete='one-time-code'
                                    label={["State Name ", <span key={"State Name"} className={classes.colorRedRequired}> *</span>]}
                                    variant={'standard'}
                                    error={errorStateName && true}
                                    helperText={errorStateName}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => setName(e.target.value)}
                                />
                                <TextField autoComplete='one-time-code'
                                    label='Short Name'
                                    variant={'standard'}
                                    className={clsx(classes.margin30t)}
                                    error={errorStateShortName && true}
                                    helperText={errorStateShortName}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => setShortName(e.target.value)}
                                />
                                <AutoCompleteComponent
                                    name={["Country ", <span key={"Country"} className={classes.colorRedRequired}> *</span>]}
                                    heads={[{ 'key': 'name', 'name': 'Country Name' }]}
                                    details={countryDetails}
                                    parentValue={customObject(countryDetails, countryId)}
                                    onChange={(data) => { setCountryId(data.id); setCountry(data) }}
                                    position={'bottom'}
                                    parentError={errorCountryId}
                                    customClasses={classes.margin30t}
                                />
                                {
                                    country?.name === 'India' && <FormControlLabel
                                        classes={{
                                            label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink') // Pass your override css here
                                        }}
                                        control={<Switch size='small'
                                            className={clsx(classes.customSwitch)}
                                            onChange={(e) => setIsUtgst(!isUtgst)}
                                            checked={isUtgst}
                                        />}
                                        label="Is Union Territory?"
                                        labelPlacement="top"
                                        className={clsx(classes.marginLeft0, classes.flexStart, classes.margin20t)}
                                    />
                                }
                            </div>
                            <div className={clsx(classes.btnParent)}>
                                <Button
                                    key="add"
                                    type='submit'
                                    color='primary'
                                    variant="contained"
                                    className={clsx(classes.modalBtn, { [classes.loading]: createLoader })}>
                                    Save
                                </Button>
                            </div>
                        </Box>
                    }
                />
                <ImportExport
                    handleClose={() => handleImportClose()}
                    visible={importVisible}
                    title={'State'}
                    type={type}
                    details={stateDetails}
                    loader={stateLoader}
                    loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                    loadTasks={() => { dispatchFilter(sortBy, sortOrder) }}
                />
            </div>
        </React.Fragment >
    )
}

export default State